The `CandidateProfile` associated with the application.

This field is only accessible while you have an active `ApplicationExport` relationship with the hirer.
If this relationship has been removed, it will return null along with a `FORBIDDEN` error.
